import React from 'react';

const PresentationSEO = () => {
  return (
    <section className="py-16 px-4 bg-slate-900/50">
      <div className="max-w-5xl mx-auto">
        <div className="bg-slate-800/50 backdrop-blur-sm p-8 md:p-12 rounded-2xl border border-slate-700">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Votre spécialiste automobile à Creutzwald
          </h2>
          
          <div className="space-y-4 text-gray-300 text-lg leading-relaxed">
            <p>
              <strong className="text-white">JC Performance-57</strong> est spécialisé dans le <strong className="text-red-600">diagnostic et la gestion électronique automobile à Creutzwald</strong>, en Moselle.
            </p>
            
            <p>
              Nous intervenons sur les <strong className="text-white">pannes électroniques et électriques complexes</strong>, la recherche de panne, la réparation de faisceaux et câblages ainsi que la lecture et l'écriture des calculateurs moteur.
            </p>
            
            <p>
              Nous proposons également la <strong className="text-white">reprogrammation moteur</strong> et différentes solutions liées à la gestion moteur, selon le véhicule et son utilisation.
            </p>
            
            <p className="text-xl text-red-600 font-semibold pt-4">
              Notre objectif : identifier précisément la panne et apporter une solution professionnelle, adaptée à votre véhicule.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PresentationSEO;
